<template>
  <div class="section-controls d-flex flex-column align-items-center justify-content-center">
    <b-icon-trash role="button" class="delete" @click="deleteSection"></b-icon-trash>

    <b-icon-arrow-up
      v-if="withOrdering"
      role="button"
      @click="moveSection(false)"
      :disabled="index < 1"
    />
    <b-icon-arrow-down v-if="withOrdering" role="button" @click="moveSection(true)" />
  </div>
</template>
<script lang="ts">
import { useCaseStudyStore } from '@app/stores/CaseStudyStore'

export default {
  props: {
    caseStudyId: { type: Number, required: true },
    index: { type: Number, required: true },
    withOrdering: { type: Boolean, default: true },
  },
  methods: {
    moveSection(forward) {
      useCaseStudyStore().moveSection(this.caseStudyId, this.index, forward)
    },
    deleteSection() {
      if (confirm('Are you sure about deleting this section?')) {
        useCaseStudyStore().deleteSection(this.caseStudyId, this.index)
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.section-controls
  gap: 12px
  color: black
  background: white
  border: 1px solid var(--border-color)
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1)
  border-radius: 8px
  padding: 8px
  height: 90px
</style>
